<template>
  <div v-if="active" class="orcamento-loading">
    <div class="orcamento-loading__scene">
      <div class="orcamento-loading__cube">
        <div class="face face--front">
          <span class="face__tape"></span>
        </div>
        <div class="face face--back">
          <span class="face__tape"></span>
        </div>
        <div class="face face--right"></div>
        <div class="face face--left"></div>
        <div class="face face--top">
          <span class="face__tape face__tape--top"></span>
        </div>
        <div class="face face--bottom"></div>
      </div>
    </div>
    <p class="orcamento-loading__text">
      {{ currentLabel }}<span class="orcamento-loading__dots">{{ dots }}</span>
    </p>
  </div>
</template>

<script>
const STEP_INTERVAL_MS = 1500;
const DOT_INTERVAL_MS = 400;

export default {
  name: "OrcamentoLoading",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    steps: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      stepIndex: 0,
      dotCount: 1,
      stepTimer: null,
      dotTimer: null,
    };
  },
  computed: {
    currentLabel() {
      const step = this.steps[this.stepIndex];
      return step ? step.label : "Carregando";
    },
    dots() {
      return ".".repeat(this.dotCount);
    },
  },
  watch: {
    active: {
      immediate: true,
      handler(value) {
        if (value) {
          this.start();
        } else {
          this.stop();
        }
      },
    },
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    start() {
      this.stop();
      this.stepIndex = 0;
      this.dotCount = 1;

      this.dotTimer = setInterval(() => {
        this.dotCount = this.dotCount >= 3 ? 1 : this.dotCount + 1;
      }, DOT_INTERVAL_MS);

      this.stepTimer = setInterval(() => {
        if (!this.steps.length) return;
        this.stepIndex = (this.stepIndex + 1) % this.steps.length;
      }, STEP_INTERVAL_MS);
    },
    stop() {
      if (this.stepTimer) {
        clearInterval(this.stepTimer);
        this.stepTimer = null;
      }
      if (this.dotTimer) {
        clearInterval(this.dotTimer);
        this.dotTimer = null;
      }
    },
  },
};
</script>

<style scoped>
.orcamento-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 1.5rem;
  min-height: 280px;
  gap: 2rem;
}

.orcamento-loading__scene {
  width: 140px;
  height: 140px;
  perspective: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.orcamento-loading__cube {
  width: 72px;
  height: 72px;
  position: relative;
  transform-style: preserve-3d;
  -webkit-transform-style: preserve-3d;
  transform-origin: center center;
  animation: orcamento-cube-spin 2.8s linear infinite;
}

.face {
  position: absolute;
  top: 0;
  left: 0;
  width: 72px;
  height: 72px;
  border: 1px solid #c4a574;
  background: linear-gradient(145deg, #e8c99a 0%, #d4a96a 55%, #c4924f 100%);
  box-sizing: border-box;
  backface-visibility: visible;
  -webkit-backface-visibility: visible;
  box-shadow: inset 0 0 12px rgba(120, 80, 30, 0.18);
}

.face__tape {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 10px;
  margin-left: -5px;
  background: rgba(255, 236, 179, 0.75);
  box-shadow: inset 0 0 0 1px rgba(196, 165, 116, 0.35);
}

.face__tape--top {
  top: 50%;
  bottom: auto;
  left: 0;
  right: 0;
  width: auto;
  height: 10px;
  margin: -5px 0 0;
}

.face--front {
  transform: translateZ(36px);
}

.face--back {
  transform: rotateY(180deg) translateZ(36px);
}

.face--right {
  transform: rotateY(90deg) translateZ(36px);
  background: linear-gradient(145deg, #d9b67a 0%, #c4924f 100%);
}

.face--left {
  transform: rotateY(-90deg) translateZ(36px);
  background: linear-gradient(145deg, #d9b67a 0%, #c4924f 100%);
}

.face--top {
  transform: rotateX(90deg) translateZ(36px);
  background: linear-gradient(145deg, #f0d4a8 0%, #e0b87a 100%);
}

.face--bottom {
  transform: rotateX(-90deg) translateZ(36px);
  background: linear-gradient(145deg, #b88445 0%, #a06e35 100%);
}

.orcamento-loading__text {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: #5c6873;
  text-align: center;
  min-height: 1.5em;
}

.orcamento-loading__dots {
  display: inline-block;
  min-width: 1.5em;
  text-align: left;
}

@keyframes orcamento-cube-spin {
  0% {
    transform: rotateX(-22deg) rotateY(0deg);
  }
  100% {
    transform: rotateX(-22deg) rotateY(360deg);
  }
}
</style>
